import ExperiencePage from '../templates/ExperiencePage';
import Page from '../templates/Page';

export const pageTemplatesByPath = {
  './src/templates/Page.tsx': Page,
  './src/templates/ExperiencePage.tsx': ExperiencePage,
};
